import { Box, CircularProgress } from "@mui/material";
import React from "react";

const LoadingSkeleton = () => (
  <Box sx={{ justifyContent: 'center', alignItems: 'center', display: 'flex', flex: 1, height: '100%' }}>
    <CircularProgress />
  </Box>
);
export default LoadingSkeleton;
